import { render, staticRenderFns } from "./addJob.vue?vue&type=template&id=2efb7a22&scoped=true&"
import script from "./addJob.vue?vue&type=script&lang=js&"
export * from "./addJob.vue?vue&type=script&lang=js&"
import style0 from "./addJob.vue?vue&type=style&index=0&id=2efb7a22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efb7a22",
  null
  
)

export default component.exports